import apiService from '../http.service';
import { appConfig } from '../../app.config';


class LoadsTabService {

  classes;
  levels;
  sides;

  getSeismicityLevels() {
    return apiService.get({ query: appConfig.path.SEISMICITY_LEVELS })
        .then(levels => this.levels = levels);
  }

  getBuildingImportance() {
    return apiService.get({ query: appConfig.path.BUILDING_IMPORTANCE })
        .then(classes => this.classes = classes);
  }

  getFireSides() {
    return this.sides
      ? Promise.resolve(this.sides)
      : apiService.get({ query: appConfig.path.FIRE_SIDES })
        .then(sides => this.sides = sides);
  }

  getFrenchAreas(postalCode) {
    return apiService.get({ query: `${appConfig.path.GET_FRENCH_AREAS}?postalCode=${postalCode}` });
  }
  
}

export default new LoadsTabService();



// WEBPACK FOOTER //
// ./src/services/requests/loads-tab.service.js